import { Component, HostBinding, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IndexService } from './index.service';

@Component({
	selector: 'common-index',
	templateUrl: './index.component.html',
	styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {
	// classåå c-ï¼é²æ­¢éå
	@HostBinding('class.c-index') hostClass = true;

	constructor(public svr: IndexService, private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer) {
		this.svr.init();
		const icons = ['arrow_expand'];
		icons.forEach(v => {
			iconRegistry.addSvgIcon(v, sanitizer.bypassSecurityTrustResourceUrl('assets/index/icon/' + v + '.svg'));
		});
	}
	ngOnInit() {}

	test() {
		console.log(this.svr.userSetting.Layout);
	}
}
